import React, {useEffect, useState} from 'react';
import SimpleTable from '../../components/SimpleTable';
import {Header, Loading} from '../../components';
import {Manager} from "../../core";
import {CustomerStore} from "../../stores/customers/customersStore";
import {Colors} from "../../styles";
import { AiOutlineNotification } from 'react-icons/ai';
import { NotificationsStore } from '../../stores/notifications/notificationsStore';

// helper renderers removed (unused) to satisfy linter

// Função auxiliar para converter UTC do banco para Horário Local
const formatDateTime = (dateStr: string) => {
	if (!dateStr || dateStr === '-') return '-';
	try {
		// Ajusta formato YYYY-MM-DD HH:mm:ss para ISO antes de converter
		const isoStr = dateStr.includes('T') ? dateStr : dateStr.replace(' ', 'T');
		const utcStr = isoStr.endsWith('Z') || isoStr.includes('+') ? isoStr : `${isoStr}Z`;
		const date = new Date(utcStr);
		return date.toLocaleString('pt-BR', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit'
		});
	} catch (e) {
		return dateStr;
	}
};

export const customersGrid = [
	{
		field: 'name',
		headerText: 'Nome',
		width: '100',
		textAlign: 'Center'
	},
	{
		field: 'surname',
		headerText: 'Sobrenome',
		width: '100',
		format: 'yMd',
		textAlign: 'Center',
	},
	{
		field: 'email',
		headerText: 'Email',
		width: '200',
		textAlign: 'Center'
	},
	{
		field: 'cellphone',
		headerText: 'Celular',
		width: '150',
		textAlign: 'Center'
	},

	{
		field: 'createdAt',
		headerText: 'Criado em',
		width: '200',
		textAlign: 'Center',
		template: (row: any) => formatDateTime(row.createdAt),
	},
];


export const Customers = () => {
	const { list, delete: deleteUser } = CustomerStore();
	const [loading, setLoading] = useState(false);
	const [selectedUser, setSelectedUser] = useState<any>(null);

	const [loadingNotify, setLoadingNotify] = useState(false);
	const [notifyTitle, setNotifyTitle] = useState("");
	const [notifyMsg, setNotifyMsg] = useState("");

	useEffect( () => {
		setLoading(true)
		const handlerRequest = async () => {
			try {
				await CustomerStore().get();
				setLoading(false);
			} catch (e) {
				setLoading(false);
				Manager.RequestError('error.customers.handlerRequest', e);
			}
		};

		handlerRequest().then((r) => r);
	}, []);

	const handleDelete = async () => {
		if (!selectedUser) return;
		// eslint-disable-next-line no-alert
		if (window.confirm(`Deseja realmente excluir o usuário ${selectedUser.name}?`)) {
			try {
				setLoading(true);
				await deleteUser(selectedUser.id);
				setSelectedUser(null);
				setLoading(false);
			} catch (e) {
				setLoading(false);
				Manager.RequestError('error.customers.handleDelete', e);
			}
		}
	};

	const handleSendNotification = async () => {
		if (!selectedUser) return;
		const userId = selectedUser.id;
		const fcmId = selectedUser.fcmId;

		if (!userId || !fcmId) {
			alert("Usuário sem identificação para notificação (FCM ID ausente).");
			return;
		}

		if (!notifyTitle.trim() || !notifyMsg.trim()) {
			alert("Por favor, preencha o título e a mensagem da notificação.");
			return;
		}

		setLoadingNotify(true);
		try {
			await NotificationsStore().pushToUser(userId, fcmId, notifyTitle, notifyMsg);
			alert("Notificação enviada com sucesso!");
			setNotifyTitle("");
			setNotifyMsg("");
		} catch (err) {
			console.error(err);
			alert("Falha ao enviar notificação.");
		} finally {
			setLoadingNotify(false);
		}
	};

	return (
		<div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white dark:bg-secondary-dark-bg dark:text-gray-200 rounded-3xl">
			{loading && (
				<div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 50}}>
					<Loading backgroundColor={Colors.light} type={'bubbles'} color={Colors.green_darker} />
				</div>
			)}
			<Header category="Página" title="Clientes"/>
			<SimpleTable 
				columns={customersGrid as any} 
				data={list} 
				pageSize={10} 
				onRowClick={(row) => setSelectedUser(row)}
			/>

			{selectedUser && (
				<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
					<div className="bg-white dark:bg-[#33373E] p-6 rounded-2xl w-full max-w-md shadow-xl">
						<div className="flex justify-between items-center mb-6">
							<h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100">Detalhes do Cliente</h2>
							<button onClick={() => setSelectedUser(null)} className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 text-2xl">&times;</button>
						</div>
						
						<div className="space-y-4 mb-8">
							<div>
								<p className="text-sm text-gray-500 dark:text-gray-400 uppercase font-semibold">Nome Completo</p>
								<p className="text-lg text-gray-800 dark:text-gray-200">{selectedUser.name} {selectedUser.surname}</p>
							</div>
							<div>
								<p className="text-sm text-gray-500 dark:text-gray-400 uppercase font-semibold">Email</p>
								<p className="text-lg text-gray-800 dark:text-gray-200">{selectedUser.email}</p>
							</div>
							<div className="grid grid-cols-2 gap-4">
								<div>
									<p className="text-sm text-gray-500 dark:text-gray-400 uppercase font-semibold">Celular</p>
									<p className="text-lg text-gray-800 dark:text-gray-200">{selectedUser.cellphone}</p>
								</div>
								<div>
									<p className="text-sm text-gray-500 dark:text-gray-400 uppercase font-semibold">Cadastro</p>
									<p className="text-lg text-gray-800 dark:text-gray-200">{formatDateTime(selectedUser.createdAt)}</p>
								</div>
							</div>
						</div>

						{/* SEÇÃO DE NOTIFICAÇÃO */}
						<div className="bg-[#f8f9fa] dark:bg-[#2C3038] border-[#e9ecef] dark:border-gray-700 p-4 rounded-xl border mb-6">
							<div className="text-[#495057] dark:text-gray-200 font-bold mb-4 text-sm flex items-center gap-2">
								{React.createElement(AiOutlineNotification as any, { size: 18 })}
								Notificar o Usuário
							</div>
							<div className="mb-3">
								<label className="text-[#646464] dark:text-gray-400 block text-xs font-semibold mb-1">Título</label>
								<input 
									type="text" 
									value={notifyTitle} 
									onChange={(e) => setNotifyTitle(e.target.value)}
									placeholder="Título da notificação"
									className="w-full bg-white dark:bg-[#20232A] text-[#333] dark:text-gray-200 border-[#ced4da] dark:border-gray-600 p-2 rounded-lg border text-sm focus:outline-none"
								/>
							</div>
							<div className="mb-4">
								<label className="text-[#646464] dark:text-gray-400 block text-xs font-semibold mb-1">Mensagem</label>
								<textarea 
									rows={3}
									value={notifyMsg} 
									onChange={(e) => setNotifyMsg(e.target.value)}
									placeholder="Mensagem da notificação"
									className="w-full bg-white dark:bg-[#20232A] text-[#333] dark:text-gray-200 border-[#ced4da] dark:border-gray-600 p-2 rounded-lg border text-sm focus:outline-none resize-none"
								/>
							</div>
							<button
								onClick={handleSendNotification}
								disabled={loadingNotify || !notifyTitle.trim() || !notifyMsg.trim()}
								className={`w-full py-2 rounded-lg font-bold text-sm transition-colors ${
									(loadingNotify || !notifyTitle.trim() || !notifyMsg.trim()) 
										? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
										: 'bg-orange-500 hover:bg-orange-600 text-white shadow-md'
								}`}
							>
								{loadingNotify ? 'Enviando...' : 'Enviar Notificação'}
							</button>
						</div>

						<div className="flex gap-3 mt-6">
							<button 
								onClick={handleDelete}
								className="flex-1 bg-red-500 hover:bg-red-600 text-white font-bold py-3 rounded-xl transition-colors shadow-lg shadow-red-200"
							>
								Excluir Usuário
							</button>
							<button 
								onClick={() => setSelectedUser(null)}
								className="flex-1 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 font-bold py-3 rounded-xl transition-colors"
							>
								Fechar
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};
